import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NewOrderComponent } from '../new-order.component';

@Component({
    selector: 'app-new-land-search',
    templateUrl: './new-land-search.component.html',
    styleUrl: './new-land-search.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewLandSearchComponent extends NewOrderComponent {

}
